import axios from 'axios';

const HttpClient = axios.create({
    baseURL: '/.netlify/functions',
    timeout: 60 * 1000,
  });

export default HttpClient;